import { render } from "./Suggestions.vue?vue&type=template&id=08dd18da&ts=true"
import script from "./Suggestions.vue?vue&type=script&setup=true&lang=ts"
export * from "./Suggestions.vue?vue&type=script&setup=true&lang=ts"

import "./Suggestions.vue?vue&type=style&index=0&id=08dd18da&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/components/autocomplete/Suggestions.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "08dd18da"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('08dd18da', __exports__)) {
    api.reload('08dd18da', __exports__)
  }
  
  module.hot.accept("./Suggestions.vue?vue&type=template&id=08dd18da&ts=true", () => {
    api.rerender('08dd18da', render)
  })

}


export default __exports__